import React from "react";
import { Link } from "react-router-dom";
import "./History.css";

const AboutLibrary = () => {
  return (
    <div className="about-library-container">

      {/* LEFT SIDE */}
      <div className="about-library-left">

        <p className="first-para">
          ग्रंथालयाची पायाभरणी ही संस्थापकांचे आजोबा
          <span className="highlight-date">
            {" "}कै. रघुनाथ रामचंद्र बुरांडे
          </span>{" "}
          गुरुजी यांच्या प्रेरणेतून झाली आहे. कोडोली गावातील
          संस्कृत विषयाचे आदरणीय शिक्षक म्हणून त्यांची ओळख होती.
          पुस्तकांवरील त्यांचे अतूट प्रेम व समाजात ज्ञानप्रसार
          करण्याची तळमळ ही त्यांच्या जीवनमूल्यांची ओळख होती.
        </p>

        <p>
          हेच संस्कार व शैक्षणिक मूल्ये त्यांचे नातू
          <span className="highlight-bold">
            {" "}श्री. मकरंद जगन्नाथ बुरांडे
          </span>{" "}
          यांना लाभली. सामाजिक सेवेची आवड व आजोबांचे स्वप्न
          साकार करण्याच्या उद्देशाने ग्रंथालयाची स्थापना
          करण्यात आली. वाचनसंस्कृतीचा प्रसार, सांस्कृतिक
          मूल्यांचे जतन व बौद्धिक वारसा पुढे नेण्याच्या हेतूने
          या ग्रंथालयासाठी त्यांनी स्वतःच्या बचतीतून सुमारे
          <span className="highlight-bold"> २८ लाख रुपये</span>{" "}
          इतकी मोठी रक्कम गुंतविली.
        </p>

        <p>
          आज तितक्याच तन्मयतेने हा वाचन चळवळीचा वारसा अध्यक्ष यांचे 
          चिरंजीव ग्रंथालयाचे <span className="highlight-bold">
            {" "}खजिनदार श्री ओंकार मकरंद बुरांडे
          </span>{" "}  हे करत असून
           ग्रंथालयाचे व्यवस्थापन ते स्वतः करत आहेत.
        </p>

        <p>
          या प्रकल्पाच्या सर्वांगीण विकासासाठी अनेक
          व्यक्ती व स्थानिक संस्थांनीही आपल्या क्षमतेनुसार
          सहकार्य केले आहे. त्यामुळेच आज या ग्रंथालयास
          स्वतःची स्वतंत्र इमारत व अभ्यासिका उपलब्ध आहे.
        </p>

        <p>
          भाड्याच्या छोट्या खोलीतून सुरू झालेला हा उपक्रम
          आज सुसज्ज, प्रशस्त आणि स्वतंत्र इमारतीत विकसित
          झाला आहे. सध्या ग्रंथालयाकडे
          <span className="highlight-bold"> ५०० पेक्षा अधिक सभासद</span>{" "}
          असून
          <span className="highlight-bold"> १०,००० हून अधिक मौल्यवान पुस्तके</span>{" "}
          वाचकांसाठी उपलब्ध आहेत.
        </p>

        <p>
          महाराष्ट्र शासनाकडून
          <span className="highlight-bold">
            {" "}‘डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय पुरस्कार’
          </span>{" "}
          मिळाल्याचा आम्हाला अभिमान आहे. ज्ञान, संस्कृती
          व सामाजिक सेवेचे प्रतीक म्हणून हे ग्रंथालय
          सातत्याने कार्यरत आहे.
          <Link to="/more-history" className="read-more-inline">
            अधिक वाचा
          </Link>
        </p>

      </div>

      {/* RIGHT SIDE */}
      <div className="library-management-box">

        <div className="library-management-header">
          ग्रंथालय व्यवस्थापन
        </div>

        <ul className="library-management-list">
          <li><Link to="/founderpresident">संस्थापक व अध्यक्ष</Link></li>
          <li><Link to="/director">संचालक मंडळ</Link></li>
          <li><Link to="/executive-committee">कार्यकारिणी</Link></li>
          <li><Link to="/advisory-committee">सल्लागार समिती</Link></li>
        </ul>

      </div>

    </div>
  );
};

export default AboutLibrary;